import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PharmacyDistributionHeader from "../components/pharmacyDistributionHeader";
import PaginationFooter from "../../../components/footer/paginationFooter";
import { formatDateTransaction } from "../../../helper/formatDate";
import { Constant } from "../../../helper/constant";
import PharmacyDistributioData from "../components/pharmacyDistributionData";

const PharmacyDistribution = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [period, setPeriod] = useState("");
  const [productDistribution, setProductDistribution] = useState([]);

  // =====================
  // Method
  // =====================

  const onSearchButtonCliked = (data) => {
    setFilterData({
      start_date: data.startDate,
      end_date: data.endDate,
      keyword: data.keyword,
      product_start_character: data.searchStartCharacter
    });
  };

  const onNextPageClicked = () => {
    if (page < totalPage) {
      setPage((prevPage) => {
        return prevPage + 1;
      });
    }
  };

  const onPreviousPageClicked = () => {
    if (page !== 1) {
      setPage((prevPage) => {
        return prevPage - 1;
      });
    }
  };

  const onDownloadPharmacyDistribution = () => {
    if (filterData != null) {
      console.log("masuk sini mau download");
      downloadPharmacyDistribution(filterData.start_date, filterData.end_date);
    }
  };

  // =====================
  // Network
  // =====================

  const getProductDistribution = useCallback(async () => {
    try {
      setIsLoading(true);

      const params = new URLSearchParams({
        start_date: formatDateTransaction(filterData.start_date, "daily"),
        end_date: formatDateTransaction(filterData.end_date, "daily"),
        keyword: filterData.keyword,
        page: page,
      });

      if (filterData?.product_start_character) {
        params.append('product_start_character', filterData.product_start_character)
      }

      const url = `${Constant.BASE_API_URL}/produk-transaksi/pharmacy-stock-distribution?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;

      if (!data.product_distribution) {
        setProductDistribution([]);
      } else {
        setProductDistribution(data.product_distribution);
        setPeriod(data.date);
      }
      setTotalPage(data.total_page);
    } catch (error) {
      setProductDistribution([]);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, filterData, page]);

  const downloadPharmacyDistribution = async (startDate, endDate) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/produk-transaksi/download-record",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify({
            start_date: formatDateTransaction(filterData.start_date, "daily"),
            end_date: formatDateTransaction(filterData.end_date, "daily"),
            product_start_character: filterData.product_start_character,
          }),
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
      const blob = await response.blob();

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const filename = `data-stok-terjual-dan-sisa-${startDate}-${endDate}.xlsx`;
      link.download = filename;
      link.click();
    } catch (error) {
      alert("Terdapat Kesalahan Dalam Mendownload Data");
    }
  };

  // =====================
  // UseEffect Hook
  // =====================

  useEffect(() => {
    getProductDistribution();
  }, [getProductDistribution]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Distribusi Stok</h1>
      <PharmacyDistributionHeader
        onSearchButtonCliked={onSearchButtonCliked}
        onDownloadPharmacyDistributionClicked={onDownloadPharmacyDistribution}
      />
      <PharmacyDistributioData
        page={page}
        pharmacyDistributionData={productDistribution}
        period={period}
      />
      <PaginationFooter
        isPreviousActive={page > 1}
        isNextActive={page < totalPage}
        onNextClick={onNextPageClicked}
        onPrevClick={onPreviousPageClicked}
      />
    </div>
  );
};

export default PharmacyDistribution;
